import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/oneoffcampaign/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const clickEvent = values && values.clickEvent;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  let action = "afterlogin/oneoffcampaign/update/" + values.id;
  if (clickEvent && clickEvent === "statusupdate") {
    action = "afterlogin/oneoffcampaign/isactive/" + values.id;
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const oneoff_type = values && values.oneoff_type ? values.oneoff_type : "";
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/oneoffcampaign/view?page=${page}` : `afterlogin/oneoffcampaign/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    client_id: values && values.client_id ? values.client_id : "",
    result: result, //business_name,owner_name
    oneoff_type: oneoff_type, //business_name,owner_name
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/oneoffcampaign/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const oneoffpayment = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["paymentIntent", "PaymentMethodData"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = `afterlogin/oneoffcampaign/oneoffpayment`;
  formData.append("action", action);
  formData.append("auth_key", auth_key);
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const oneoffpaymentfailed = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["error"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = `afterlogin/oneoffcampaign/oneoffpaymentfailed`;
  formData.append("action", action);
  formData.append("auth_key", auth_key);
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const oneoffcardsDefaultList = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const result = values && values.result ? values.result : "row_array";
  const action = `afterlogin/test/listPaymentMethod`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false, //true or false
    id: values && values.id ? values.id : "",
    result: result
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const sendemail = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = 'afterlogin/oneoffcampaign/sendemail';
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const OneoffCampaignApiController = {
  create,
  update,
  view,
  deleted,
  oneoffcardsDefaultList,
  oneoffpaymentfailed,
  oneoffpayment,
  sendemail
};
export default OneoffCampaignApiController;
